import { PermanentJobsApi } from '../clients';
import { IPublishDraftJobPostPayload } from '../types';

export const publishDraftJobPost = async (payload: IPublishDraftJobPostPayload): Promise<void> => {
  await PermanentJobsApi.publishDraftJobPost(payload);
};
